import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function LegsIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M27.6757 30.2832C27.4766 30.5087 27.2325 30.6891 26.9595 30.8126C26.6864 30.9361 26.3906 31 26.0913 31H20.6791C20.2058 30.9999 19.7461 30.8401 19.3731 30.546C19 30.2519 18.7351 29.8404 18.6203 29.3768L15.6085 17.2032L12.5947 29.3768C12.4799 29.8405 12.2148 30.2523 11.8415 30.5464C11.4683 30.8405 11.0083 31.0001 10.5349 31H5.12262C4.82337 31 4.5275 30.9361 4.25443 30.8126C3.98135 30.689 3.73724 30.5086 3.53811 30.283C3.33899 30.0575 3.18935 29.792 3.09901 29.504C3.00868 29.216 2.9797 28.9119 3.01396 28.6117L6.06391 1.94929C6.09363 1.68789 6.21756 1.44668 6.4121 1.27161C6.60663 1.09654 6.85818 0.999864 7.11877 1H24.0984C24.3588 1.00013 24.6101 1.09692 24.8043 1.27197C24.9987 1.44701 25.1225 1.68808 25.1521 1.94929L28.1999 28.6117C28.2342 28.912 28.2053 29.216 28.1149 29.5041C28.0246 29.7921 27.8749 30.0576 27.6757 30.2832Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
